import React from 'react'
import Image from '../Image'
import Link from '../Link'
import ArrowRight from '../../../assets/images/ArrowRight.svg'

import {
  ffOuterContainer,
  ffInnerContainer,
  ffColumnContainer,
  ffHeadingContainer,
  ffColumn,
  ffDark,
  ffTextContainer,
  ctaLink,
  ctaLinkArrow,
  ffImageLeft,
  ffImageRight,
} from './index.module.css'

const FiftyFiftyWithTitle = ({
  title,
  components,
  isDarkTheme,
  hideTitle,
  backgroundColor,
}) => {
  const defaultBackgroundColor = isDarkTheme ? '#000' : '#F8F8F8'
  return (
    <div
      className={isDarkTheme ? ffDark : ''}
      style={{
        backgroundColor: backgroundColor
          ? backgroundColor
          : defaultBackgroundColor,
      }}
    >
      <div className={['wrapper', ffOuterContainer].join(' ')}>
        <div className={['container', ffInnerContainer].join(' ')}>
          {(hideTitle === null || hideTitle === false) && title && (
            <div className={ffHeadingContainer}>
              <h2>{title}</h2>
            </div>
          )}
          {components &&
            components.map((component) => {
              const imagePositionClass =
                component.imageTextPosition !== null &&
                component.imageTextPosition === 'left'
                  ? ffImageLeft
                  : ffImageRight
              return (
                <div
                  className={[ffColumnContainer, imagePositionClass].join(' ')}
                >
                  {component.image && (
                    <div className={ffColumn}>
                      <Image
                        source={component.image}
                        altText={component.image?.description}
                      />
                    </div>
                  )}
                  <div className={ffColumn}>
                    <div className={ffTextContainer}>
                      <h3>{component.title}</h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: component.subtitle.childMarkdownRemark.html,
                        }}
                      />
                      {component.ctaText && component.ctaUrl && (
                        <Link className={ctaLink} to={component.ctaUrl}>
                          {component.ctaText}
                          <ArrowRight className={ctaLinkArrow} />
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default FiftyFiftyWithTitle
